__turbopack_context__.v({
  "date": "dateList-module-scss-module___QQbqq__date",
  "dateList": "dateList-module-scss-module___QQbqq__dateList",
  "dateWrapper": "dateList-module-scss-module___QQbqq__dateWrapper",
  "day": "dateList-module-scss-module___QQbqq__day",
  "header": "dateList-module-scss-module___QQbqq__header",
  "hour": "dateList-module-scss-module___QQbqq__hour",
  "showMore": "dateList-module-scss-module___QQbqq__showMore",
  "time": "dateList-module-scss-module___QQbqq__time",
  "venue": "dateList-module-scss-module___QQbqq__venue",
});
